import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import FileInput from "./FileInput";
import Button from "../../shared/button/Button";
import EmployerActionsList from "./EmployerActionsList";
import FormSubmitting from "./FormSubmitting";
import {
  CandidateActionsWrapper,
  Form,
  Top,
  Bottom,
  ActionsButton,
  SelectedAction,
  RemoveAction,
  TextArea,
  AttachmentPopupTrigger,
  AttachmentPopup,
  AttachmentCounter,
  NotePopup,
  Note,
  Asterisk,
  CloseButton,
  PlaceholderBtn,
  TextAreaWrapper,
} from "./styles/candidate-actions-styles";

class EmployerCandidateActions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      textareaFocused: false,
    };
  }

  handleFocus = () => {
    const { textareaFocused } = this.state;
    this.setState({
      textareaFocused: !textareaFocused,
    });
  };

  render() {
    const {
      actionsDropdown,
      attachmentChange,
      fileInput,
      fileSelected,
      handleMessageChange,
      handleSubmit,
      message,
      offerMade,
      jobFilled,
      optionHandle,
      removeActionHandle,
      removeAttachment,
      resetButtonFocus,
      selectedAction,
      toggleActionsDropdown,
      handleAttachmentPopup,
      attachmentPopupActive,
      isEmployer,
      action,
      jobStatus,
      formSubmitting,
    } = this.props;

    const { textareaFocused } = this.state;

    return (
      <CandidateActionsWrapper focused={textareaFocused}>
        {formSubmitting && <FormSubmitting />}
        <Form action="" onSubmit={handleSubmit}>
          <Top>
            {!selectedAction && (
              <ActionsButton
                onClick={toggleActionsDropdown}
                actionsDropdown={actionsDropdown}
                className="dropdown"
                data-test-id="actions-dropdown"
                selectedAction={selectedAction}
              >
                Add action
                <FontAwesomeIcon icon={faPlusCircle} />
              </ActionsButton>
            )}

            <SelectedAction active={selectedAction}>
              {selectedAction}
              <RemoveAction onClick={removeActionHandle} />
            </SelectedAction>
            <EmployerActionsList
              actionsDropdown={actionsDropdown}
              optionHandle={optionHandle}
              offerMade={offerMade}
              jobFilled={jobFilled}
              jobStatus={jobStatus}
            />
            {action === "rejected_candidate" && message.length < 30 && (
              <Fragment>
                <NotePopup className="animated fadeInUp">
                  Before you reject, think of the human being who will receive
                  this.
                  <br />
                  If this were your application, what would you like as
                  constructive feedback?
                </NotePopup>
                <Note>
                  <Asterisk>*</Asterisk>
                  minimum of 30 characters
                </Note>
              </Fragment>
            )}
          </Top>
          <AttachmentPopupTrigger
            selectedAction={selectedAction}
            textareaFocused={textareaFocused}
            onClick={selectedAction ? handleAttachmentPopup : null}
          />
          {fileSelected && <AttachmentCounter />}
          <AttachmentPopup active={attachmentPopupActive}>
            <CloseButton onClick={handleAttachmentPopup} />
            <FileInput
              ref={fileInput}
              fileSelected={fileSelected}
              attachmentChange={attachmentChange}
              removeAttachment={removeAttachment}
            />
          </AttachmentPopup>
          <Bottom>
            <TextAreaWrapper focused={textareaFocused}>
              <TextArea
                id="candidate-actions-ta"
                placeholder={selectedAction && "Enter message here..."}
                onChange={handleMessageChange}
                value={message}
                focused={textareaFocused}
                onFocus={this.handleFocus}
                onBlur={this.handleFocus}
                actionsActive={isEmployer}
                selectedAction={selectedAction}
                disabled={(!selectedAction || formSubmitting) && "disabled"}
              />
            </TextAreaWrapper>
            {action === "rejected_candidate" && message.length < 30 ? (
              <PlaceholderBtn data-test-id="fake-reject-button" />
            ) : (
              <Button
                classes="submit-action"
                disabled={formSubmitting || !selectedAction}
                resetButtonFocus={resetButtonFocus}
                textareaFocused={textareaFocused}
                dataTestId="submit-action"
                id="submit-candidate-action"
              />
            )}
          </Bottom>
        </Form>
      </CandidateActionsWrapper>
    );
  }
}

EmployerCandidateActions.propTypes = {
  toggleActionsDropdown: PropTypes.func.isRequired,
  actionsDropdown: PropTypes.bool.isRequired,
  offerMade: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  selectedAction: PropTypes.string.isRequired,
  removeActionHandle: PropTypes.func.isRequired,
  optionHandle: PropTypes.func.isRequired,
  handleMessageChange: PropTypes.func.isRequired,
  fileInput: PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    .isRequired,
  message: PropTypes.string.isRequired,
  fileSelected: PropTypes.bool.isRequired,
  attachmentChange: PropTypes.func.isRequired,
  isEmployer: PropTypes.bool,
  removeAttachment: PropTypes.func.isRequired,
  resetButtonFocus: PropTypes.bool.isRequired,
  handleAttachmentPopup: PropTypes.func.isRequired,
  attachmentPopupActive: PropTypes.bool.isRequired,
  jobFilled: PropTypes.bool,
  action: PropTypes.string,
  jobStatus: PropTypes.string.isRequired,
  formSubmitting: PropTypes.bool.isRequired,
};

EmployerCandidateActions.defaultProps = {
  jobFilled: PropTypes.isNull,
  isEmployer: PropTypes.isNull,
  action: PropTypes.isNull,
};

export default EmployerCandidateActions;
